import { FC, useState } from 'react';
import { useRouter } from 'next/router';
import EfSwiperLevel2 from '@elem/ui/ef-swiper-level2';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { t } = useLang('dp3.landing.Smoothly');
    const { locale } = useRouter();
    const [listA, setListA] = useState([
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717657374538/Frame%201000008360%20(1)%20(1).png',
            h5List: [
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718768487726/a1.jpg',
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718768501370/a2.jpg',
            ],
            upTitle: t('item1_t'),
            subtitle: t('item1_l'),
            desc: t('item1_r'),
            tips: t('item1_r_tips'),
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718789088169/a1.jpg',
            h5List: [
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718799251379/a1.jpg',
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718768700755/b2.jpg',
            ],
            upTitle: t('item2_t'),
            subtitle: t('item2_l'),
            desc: t('item2_r'),
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718789177451/a2.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718768989165/d1.jpg',
            upTitle: t('item3_t'),
            subtitle: t('item3_l'),
            desc: t('item3_r'),
        },
    ]);
    return (
        <div
            id="dp3-teaser-E12"
            className={`Smoothly dp3-teaser-E ${styles.theComp} GtmModuleData-section`}
            data-section-id={'dp3-SmoothlyB'}
            data-section-title={t('title')}
        >
            <div className="comp-module dp3-module-box">
                <div className="dp3-title">{t('title')}</div>
                {/* <SwiperCommon list={listA} /> */}
            </div>
            <EfSwiperLevel2 list={listA} hasLevel2={true} />
        </div>
    );
};

export default TheComp;
